// vendor
import { ref, computed, watch } from "@vue/composition-api";
// project
import * as StudyAPI from "@/services/api/studies";
import { useAssets } from "@/hooks/useAssets";
import { useTags } from "@/hooks/useTags";

export const useTagInfo = (tagId:string) => {



	const {
		assets,
	} = useAssets();

	const {
		hasTag,
	} = useTags();

	const studyCount = ref(0);

	const blueprints = computed(() => {
		return assets.value.filter(a => a.type === "Graph" && hasTag(tagId, a._id));
	});

	const elements = computed(() => {
		return assets.value.filter(a => a.type !== "Graph" && hasTag(tagId, a._id));
	});

	const blueprintCount = computed(() => blueprints.value.length);

	const elementCount = computed(() => elements.value.length);

	const refresh = async () => {

		if(blueprintCount.value === 0){
			studyCount.value = 0;
			return;
		}

		const q = {
			"target.study[in]":blueprints.value.map(bp => bp._id).join(","),
			page:1,
			limit:1,
		};


		try {
			const { count } = await StudyAPI.getStudiesPaginated(q);
			studyCount.value = count;
		}
		catch{}
	};

	refresh();

	return {
		blueprintCount,
		elementCount,
		studyCount,
		refresh,
	};


};